// vue.module
export const SET_TIME = 'setTime'
export const SET_LOADING = 'setLoading'
export const SET_STATUS = 'setStatus'
export const SET_CONTAINER = 'setContainer'
export const SET_BLOCK_MUTATION = 'setBlockMutation'
export const SET_MODAL = 'setModal'
export const SET_SYSTEM_POPUP = 'setSystemPopup'

// text.module
export const SET_TEXTS = 'setTexts'

// settings.module
export const SET_WEBVIEW_SETTINGS = 'setWebviewSettings'
export const SET_FILTER = 'setFilter'
export const SET_PRICE_ON_PHOTO = 'setPriceOnPhoto'
export const SET_PROMOCODE_AVAILABLE = 'setPromocodeAvailable'
export const SET_BASKET_PHOTO = 'setBasketPhoto'
export const SET_BASKET_COMMENT = 'setBasketComment'
export const SET_IMAGES_STYLE = 'setImagesStyle'
export const SET_SHOW_DESCRIPTION = 'setShowDescription'
export const SET_HOME_SCROLL = 'setHomeScroll'
export const SET_SHOW_AGREE_TEXT = 'setShowAgreeText'
export const SET_SHOW_MADE_VIA_DIGARSON = 'setShowMadeViaDigarson'
export const SET_LANGUAGE = 'setLanguage'
export const SET_TIME_FORMAT = 'setTimeFormat'
export const SET_SEARCH_WIDGET = 'setSearchWidget'
export const SET_OVERLAY = 'setOverlay'
export const SET_CLIENT_INFO = 'setClientInfo'
export const SET_WHITE_LABEL = 'setWhiteLabel'
export const SET_CONTACTLESS_MODE = 'setContactlessMode'
export const SET_ERROR = 'setError'
export const SET_FORCE_GUARD = 'setForceGuard'
export const SET_GTM_TAG = 'setGtmTag'
export const SET_BLOCK_MODAL_ENABLED = 'setBlockModalEnabled'
export const SET_LAZY_COMPONENT = 'setLazyComponent'
export const SET_CUTLERY = 'setCutlery'
export const SET_CHECK_IOS = 'setCheckIos'
export const SET_SHOP_MODE = 'setShopMode'

// form.module
export const SET_PAYMENT_METHODS = 'setPaymentMethods'
export const SET_DELIVERY_SERVICES = 'setDeliveryServices'
export const SET_TIME_SELECTOR = 'setTimeSelector'
export const SET_COOK_COMMENT = 'setCookComment'
export const SET_DELIVERY_TIME_OBJECT = 'setDeliveryTimeObject'
export const SET_DELIVERY_TIME_MODE = 'setDeliveryTimeMode'
export const SET_FIELD_FULL_NAME = 'setFieldFullName'
export const SET_FIELD_EMAIL = 'setFieldEmail'
export const SET_FIELD_FULL_ADDRESS = 'setFieldFullAddress'
export const SET_FIELD_CUSTOM_FIELDS = 'setFieldCustomFields'
export const SET_FIELD_LOCAL_ADDRESS = 'setFieldLocalAddress'
export const SET_FIELD_RECIPIENT_PHONE = 'setFieldRecipientPhone'
export const SET_FIELD_MAIN_PHONE = 'setFieldMainPhone'
export const SET_SMS_PAYLOAD = 'setSmsPayload'
export const SET_SMS_TIMEOUT = 'setSmsTimeout'
export const SET_FIELD_COMMENT = 'setFieldComment'
export const SET_CHECK_IIKO = 'setCheckIiko'
export const SET_ORDER_ID = 'setOrderId'
export const SET_PAYMENT_LINK = 'setPaymentLink'
export const SET_FIELD_ADDRESS = 'setFieldAddress'

// guard.module
export const SET_WEBVIEW_GUARD = 'setWebviewGuard'
export const SET_GUARD_MODE = 'setGuardMode'
export const SET_NOT_WORKING = 'setNotWorking'
export const SET_GUARD_MODE_INITIAL = 'setGuardModeInitial'
export const SET_GUARD_CITY_ID = 'setGuardCityID'
export const SET_GUARD_CITIES = 'setGuardCities'
export const SET_GUARD_TYPE_ID = 'setGuardTypeID'
export const SET_GUARD_TYPES = 'setGuardTypes'
export const SET_GUARD_OUTLET_ID = 'setGuardOutletID'
export const SET_GUARD_OUTLETS = 'setGuardOutlets'
export const SET_GUARD_AREA_ID = 'setGuardAreaID'
export const SET_GUARD_AREA_TYPE_ID = 'setGuardAreaTypeID'
export const SET_GUARD_AREAS = 'setGuardAreas'
export const SET_GUARD_PASS = 'setGuardPass'
export const SET_GUARD_ADDRESS_ENABLED = 'setGuardAddressEnabled'
export const SET_GUARD_ADDRESS = 'setGuardAddress'
export const SET_SHOW_CHOOSE_OUTLETS_ALWAYS = 'setShowChooseOutletsAlways'
export const SET_CSS_DIRECTION = 'setCssDirection'
export const SET_NOT_ACCESS = 'setNotAccess'
export const SET_COMPANY_NAME = 'setCompanyName'

// profile.module
export const SET_TOKEN = 'setToken'
export const SET_QUERY_PARAMS = 'setQueryParams'
export const SET_IDENTITY = 'setIdentity'
export const SET_PROFILE = 'setProfile'
export const SET_ADDRESSES = 'setAddresses'
export const SET_ADDRESS_SUGGESTIONS = 'setAddressSuggestions'
export const SET_CASHBACK_SETTINGS = 'setCashbackSettings'
export const SET_GEO_ADDRESS = 'setGeoAddress'
export const SET_INPUT_GEO_ADDRESS = 'setInputGeoAddress'
export const SET_POST_CODE = 'setPostCode'
export const SET_IS_HAS_GEO = 'setIsHasGeo'
export const SET_DADATA_STREET = 'setDadataStreet'

// basket.module
export const SET_DISCOUNT = 'setDiscount'
export const SET_CONST_TOTAL_PRICE = 'setConstTotalPrice'
export const SET_PROMOCODE = 'setPromocode'
export const SET_PROMOCODE_DATA = 'setPromocodeData'
export const SET_UPSELL = 'setUpsell'
export const SET_UPSELL_MESSAGE = 'setUpsellMessage'
export const SET_TWO_PLUS_ONE_MESSAGE = 'setTwoPlusOneMessage'
export const SET_UPSELL_ITEM_COUNT = 'setUpsellItemCount'
export const SET_TOTAL_PRICE = 'setTotalPrice'
export const SET_SUM_PRODUCTS = 'setSumProducts'
export const SET_TOTAL_PRICE_NO_DISCOUNT = 'setTotalPriceNoDiscount'
export const SET_TOTAL_PRICE_ONLY_PRODUCTS_NO_DISCOUNT = 'setTotalOnlyProductsNoDiscount'
export const SET_DELIVERY_PRICE = 'setDeliveryPrice'
export const SET_SELECTED_PRODUCTS = 'setSelectedProducts'
export const SET_CURRENT_PRODUCT = 'setCurrentProduct'
export const SET_REPEAT_ORDER_ID = 'setRepeatOrderId'
export const SET_BU_ID = 'setBuId'
export const SET_RUSSIAN_POST_INFO = 'setRussianPostInfo'
export const SET_CDEK_INFO = 'setCdekInfo'
export const SET_PEK_INFO = 'setPekInfo'
export const SET_SPECIAL_DELIVERY_METHOD = 'setSpecialDeliveryMethod'
export const SET_DELIVERY_TO_CITY = 'setDeliveryToCity'
export const SET_DELIVERY_METHOD_PVZ_ID = 'setDeliveryMethodPvzId'
export const SET_DELIVERY_METHOD_PVZ_DATA = 'setDeliveryMethodPvzData'
export const SET_SERVICE_FEE_PRICE = 'setServiceFeePrice'


// outlet.module
export const SET_LINKS = 'setLinks'
export const SET_TIMES = 'setTimes'
export const SET_OUTLET = 'setOutlet'
export const SET_BOT_LINK = 'setBotLink'
export const SET_NEXT_PAGE = 'setNextPage'
export const SET_SEARCH_QUERY = 'setSearchQuery'
export const SET_SEARCH_GOT_FIRST = 'setSearchGotFirst'
export const CLEAR_SEARCH = 'clearSearch'
export const ADD_CATEGORIES = 'addCategories'
export const SET_SEARCH_CATEGORIES = 'setSearchCategories'
export const SET_SELECTED_CATEGORY = 'setSelectedCategory'
export const ADD_TO_PRODUCTS = 'addToProducts'
export const ADD_TO_POPULAR_PRODUCTS = 'addToPopularProducts'
export const ADD_TO_SEARCH_PRODUCTS = 'addToSearchProducts'
export const SET_PRODUCTS_LOADING = 'setProductsLoading'
export const SET_POPULAR_PRODUCTS_LOADING = 'setPopularProductsLoading'
export const CREATE_SELECTED_CATEGORY_FOR_LEVEL = 'createSelectedCategoryForLevel'
export const SET_PRODUCTS_COUNT_IN_CATEGORIES = 'setProductsCountInCategories'
export const SET_OPEN_LIST_MODIFIRE = 'setOpenListModifire'
export const SET_SELECTED_MODIFIRE = 'setSelectedModifire'
export const SET_DELIVERY_FROM_CITY = 'setDeliveryFromCity'